// Field accessors shared by the components that render a selected-org card (ace-header mobile card,
// ace-org-context-menu, wds/orgCard). Keeping the name-fallback, presence checks, and edition→theme
// mapping here stops the getters from being copy-pasted per component.

import { BadgeVariant, getEditionBadgeTheme } from '~/modules/helpers/badgeHelper';
import type { OrgInfo } from '~/modules/services/userService';

// Org display name, falling back to the username when the org has no friendly name.
export function getOrgName(org: OrgInfo | null | undefined): string {
    return org?.name || org?.username || '';
}

export function hasOrgEdition(org: OrgInfo | null | undefined): boolean {
    return Boolean(org?.edition);
}

export function hasOrgDomain(org: OrgInfo | null | undefined): boolean {
    return Boolean(org?.domain);
}

export function getOrgEditionBadgeTheme(org: OrgInfo | null | undefined): BadgeVariant {
    return getEditionBadgeTheme(org?.edition);
}
